import styled from 'styled-components';

const CartDescription = styled.div``;

export default CartDescription;
